import { useRef, type ReactNode } from "react"
import { useReactToPrint } from "react-to-print"
import { Printer, FileDown } from "lucide-react"
import { Button } from "./button"
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip"
import { cn } from "@/lib/utils"

interface PrintButtonProps {
  /** Conteúdo HTML a ser impresso/exportado. Renderizado off-screen. */
  content: ReactNode
  /** "print" abre diálogo de impressão, "pdf" idem (usuário salva como PDF) */
  mode?: "print" | "pdf"
  /** Título do documento na janela de impressão */
  documentTitle?: string
  /** Label do tooltip */
  label?: string
  className?: string
}

export function PrintButton({
  content,
  mode = "print",
  documentTitle = "Documento",
  label,
  className,
}: PrintButtonProps) {
  const contentRef = useRef<HTMLDivElement>(null)

  const defaultLabel = mode === "print" ? "Imprimir" : "Exportar PDF"

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle,
  })

  return (
    <>
      {/* Conteúdo renderizado off-screen para impressão */}
      <div style={{ position: "fixed", left: "-9999px", top: 0 }}>
        <div ref={contentRef}>{content}</div>
      </div>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className={cn("h-8 w-8", className)}
            onClick={() => handlePrint()}
          >
            {mode === "print" ? (
              <Printer className="h-4 w-4" />
            ) : (
              <FileDown className="h-4 w-4" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label ?? defaultLabel}</TooltipContent>
      </Tooltip>
    </>
  )
}
